/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: import.meta.env.VITE_aws_project_region,
  aws_cognito_identity_pool_id: import.meta.env
    .VITE_aws_cognito_identity_pool_id,
  aws_cognito_region: import.meta.env.VITE_aws_cognito_region,
  aws_user_pools_id: import.meta.env.VITE_aws_user_pools_id,
  aws_user_pools_web_client_id: import.meta.env
    .VITE_aws_user_pools_web_client_id,
  oauth: {
    domain: import.meta.env.VITE_oath_domain,
    scope: ['openid', 'email', 'profile'],
    redirectSignIn: import.meta.env.VITE_FRONTEND,
    redirectSignOut: import.meta.env.VITE_FRONTEND + '/logout',
    responseType: 'code'
  },
  federationTarget: 'COGNITO_USER_POOLS',
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OPTIONAL',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: []
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  aws_cognito_login_mechanisms: ['EMAIL']
}

export default awsmobile
